<template>
    <div class="row">
      <Timer v-for="parc in parcours" :key="parc.key" :parcourskey="parc.key" />
    </div>
</template>

<script>
import Timer from './Timer'
import { db } from '../firebaseDb'
import store from "../store"

export default {
  name: 'App',
  title: 'Einweisungen',
  components: {
    Timer
  },
  data () {
    return {
      backendVersion: null,
      parcours: [],
      location: store.getters.userlocation
    }
  },
  created () {
    console.log("Location in Dashboard:", this.location)
    const parcoursRef = db.collection('trainingParcours')
      parcoursRef.where('locationID', '==', this.location).orderBy('pos').onSnapshot((snapshotChange) => {
      this.parcours = []
      snapshotChange.forEach((doc) => {
        this.parcours.push({
          key: doc.id,
          parcoursID: doc.data().parcoursID
        })
      })
    })
  },
  mounted () {
  }
}
</script>
